module.exports = __webpack_public_path__ + "media/coffee-preferences/country_of_origin_el_salvador-a078e5b1.png";